import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=7c71ae9c"
import script from "./Approval.vue?vue&type=script&lang=ts"
export * from "./Approval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports